<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zgc1oJ/cover.jpeg?1718251156035" alt="This image is the cover for the book Summer of Love and Evil"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Summer of Love and Evil
      </h1>
      <p class="bookDescription body article font2">
        
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Kinnamon
      </h2>
      
      
         <a class="authorURL body link" href="https://www.publerati.com/summer-of-love-and-evil.html" target="_blank">
      
              About Author
         </a>
         <br/>
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Publerati
     </h2>
        
        
     <a class="publisherURL body link" href="https://www.publerati.com/home.html" target="_blank">
  
          About Publisher
     </a>
     <br/>
  
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5dbe9c5e